import { useLocale } from "@/i18n";
import { Notice } from "@/components/Notice";
import { MotorhomeIcon } from "@/components/ui/Icons";

export interface NoVehiclePitchNoticeProps {
  vehicleLabel?: string;
}

export function NoVehiclePitchNotice({ vehicleLabel }: NoVehiclePitchNoticeProps) {
  const { messages: m } = useLocale();

  return (
    <Notice variant="info" title={m.availability.noVehiclePitchTitle} icon={<MotorhomeIcon />}>
      <p>{m.availability.noVehiclePitchBody(vehicleLabel)}</p>
      <p className="text-sky-900/80">{m.availability.noVehiclePitchHint}</p>
    </Notice>
  );
}
